import React from 'react';

import { ProblemStage } from '../common/page-info';
import { TagScenario } from '../common-components/tag-scenario';

import { DiscourseAnswers, SFFProblemType } from '../common/page-data';
import { getImageUrlFromScenario } from '../common/helpers';
import { Discourse, DiscourseProps } from '../common-components/discourse';
import { DiscourseData } from '../page-data/discourse-data';
import { FixedOptionsComp } from '../common-components/fixed-options';
import { DiscourseFixedData } from '../page-data/discourse-fixed-data';
import { PageCompProps } from './page-comp-props';
import { Paper } from '@mui/material';

type DiscourseCompProps = PageCompProps & {
  onAnswerSelected?: DiscourseProps['onAnswerSelected'];
};

//------------------------------------------------------------------------------
export const DiscourseComp = (props: DiscourseCompProps) => {
  const { isTeacherView, stage, onReviewed, tagIdsToEmphasize } = props;
  const pageData = props.pageData as DiscourseData;
  const { scenario, skill } = pageData;
  const isFixedType = pageData.type === SFFProblemType.DiscourseFixed;
  const discourseFixedData = pageData as DiscourseFixedData;

  const onChange = (answers: DiscourseAnswers) => {
    pageData.answers = answers;
    props.onChange?.();
  };

  const skillName = skill.name.toLocaleLowerCase();

  const instruction = (
    <div>
      <b>Read the dialogue</b> between the provider and the patient. Think about
      how the provider may be demonstrating {skillName} well or poorly. Then{' '}
      <b>click</b> on each of the <b>highlighted sections</b> and{' '}
      <b>
        select the best reason it is a good or poor demonstration of {skillName}
        .
      </b>
    </div>
  );

  const Description = () => {
    return (
      <Paper
        sx={{
          bgcolor: 'info.light',
          color: 'info.contrastText',
          padding: '1em',
          overflowY: 'auto',
        }}
        elevation={3}
      >
        {pageData.question}
      </Paper>
    );
  };

  return (
    <div>
      <TagScenario
        key={`Scenario ${pageData.seed}`}
        imgUrl={getImageUrlFromScenario(scenario)}
        background={scenario?.metadata.patient.background || ''}
        content={scenario?.content?.markdown || scenario?.content.text || ''}
        description={instruction}
      />
      <Discourse
        key={`Discourse ${pageData.seed}`}
        isTeacherView={!!isTeacherView}
        tagIdsToEmphasize={tagIdsToEmphasize}
        pageData={pageData}
        problemStage={stage}
        onChange={onChange}
        onReviewed={onReviewed}
        onAnswerSelected={props.onAnswerSelected}
      />
      {isFixedType ? (
        <>
          <Description />
          <FixedOptionsComp
            isTeacherView={!!isTeacherView}
            options={discourseFixedData.fixedOptions}
            pageData={pageData}
            answer={discourseFixedData.answer}
            reason={discourseFixedData.reason}
            isReview={stage === ProblemStage.ShowResult}
            onChange={props.onChange}
            onReviewed={onReviewed}
          />
        </>
      ) : null}
    </div>
  );
};
